/**
 * Harbour phone helpers — Call (tel:), WhatsApp chat (wa.me), and copy.
 * Independent of Spartacus. tel: uses the OS default app; wa.me opens chat,
 * not a promised WhatsApp Desktop voice call.
 */

function normalizeHarbourPhone(phone) {
  const trimmed = String(phone || '').trim()
  if (!trimmed) {
    return ''
  }
  const dialable = trimmed.replace(/[^\d+]/g, '')
  if (!dialable || /^0+$/.test(dialable)) {
    return ''
  }
  return trimmed
}

export function hasHarbourPhone(cardOrPhone) {
  if (cardOrPhone && typeof cardOrPhone === 'object') {
    return Boolean(
      normalizeHarbourPhone(
        cardOrPhone.contact?.phone || cardOrPhone.phoneNumber,
      ),
    )
  }
  return Boolean(normalizeHarbourPhone(cardOrPhone))
}

export function getHarbourPhoneNumber(card = {}) {
  return normalizeHarbourPhone(card.contact?.phone || card.phoneNumber)
}

export function getHarbourPhoneHref(phone) {
  const normalized = normalizeHarbourPhone(phone)
  if (!normalized) {
    return null
  }
  const dialable = normalized.replace(/[^\d+]/g, '')
  return dialable ? `tel:${dialable}` : null
}

/**
 * Digits for wa.me (country code + number, no +). UK 07… becomes 447….
 * Returns '' when the number is missing or dummy.
 */
export function getHarbourWhatsAppNumber(phone) {
  const normalized = normalizeHarbourPhone(phone)
  if (!normalized) {
    return ''
  }

  let digits = normalized.replace(/[^\d+]/g, '')
  if (digits.startsWith('+')) {
    digits = digits.slice(1)
  } else if (digits.startsWith('00')) {
    digits = digits.slice(2)
  } else if (digits.startsWith('0')) {
    digits = `44${digits.slice(1)}`
  }

  let intl = digits.replace(/\D/g, '')
  if (intl.startsWith('440')) {
    intl = `44${intl.slice(3)}`
  }
  if (!intl || intl.length < 8) {
    return ''
  }
  return intl
}

export function getHarbourWhatsAppChatHref(phone) {
  const number = getHarbourWhatsAppNumber(phone)
  return number ? `https://wa.me/${number}` : null
}

export async function copyHarbourText(text, emptyMessage = 'Nothing to copy') {
  const value = String(text || '').trim()
  if (!value) {
    throw new Error(emptyMessage)
  }

  if (navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(value)
    return value
  }

  const textarea = document.createElement('textarea')
  textarea.value = value
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'absolute'
  textarea.style.left = '-9999px'
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  document.body.removeChild(textarea)
  return value
}

export async function copyHarbourPhone(phone) {
  return copyHarbourText(normalizeHarbourPhone(phone), 'No phone to copy')
}
